var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": "",
        title: "已有收获地址",
        visible: _vm.centerDialogVisible,
        width: "50%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": {
              backgroundColor: "#FDEFE7",
              color: "#000000",
            },
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { width: "50px", label: "选择", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: scope.row.id },
                        nativeOn: {
                          change: function ($event) {
                            return _vm.handleSelectionChange(
                              scope.$index,
                              scope.row
                            )
                          },
                        },
                        model: {
                          value: _vm.radio,
                          callback: function ($$v) {
                            _vm.radio = $$v
                          },
                          expression: "radio",
                        },
                      },
                      [_vm._v(" ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "userName",
              width: "100",
              label: "收货人姓名",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "companyName",
              width: "100",
              label: "公司",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "userPhone",
              width: "100",
              label: "手机号码",
            },
          }),
          _c("el-table-column", {
            attrs: { align: "center", prop: "address", label: "收货地址" },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }